import { db as firestore, auth } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import dexie from '../offlineDB';
import { flushPendingWrites } from './flushPendingWrites';

export async function loadTuneHybrid(user, id) {
  try {
    console.log('[Hybrid] user:', user);
    console.log('[Hybrid] Firebase Auth:', auth.currentUser);
    console.log('[Hybrid] Loading tune ID:', id);

    if (!user?.uid || !id) {
      console.warn('[Hybrid] Missing user.uid or tune ID');
      return await dexie.tunes.get(id);
    }

    if (navigator.onLine && auth.currentUser) {
      await flushPendingWrites(user);
      const docRef = doc(firestore, 'users', user.uid, 'tunes', id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = { id: docSnap.id, ...docSnap.data() };
        await dexie.tunes.put(data); // cache for offline use
        console.log('[Hybrid] Loaded from Firestore:', data);
        return data;
      } else {
        console.warn('[Hybrid] Tune not found in Firestore');
      }
    }

    const fallback = await dexie.tunes.get(id);
    console.log('[Hybrid] Loaded from Dexie:', fallback);
    return fallback;

  } catch (err) {
    console.error('Hybrid tune load failed:', err);
    return null;
  }
}
